import React, { useEffect, useState } from "react";
import { FaUtensils, FaListAlt, FaStar } from "react-icons/fa";
import "./MainPage.css";

const COOKIE_CONSENT_KEY = "cookieConsentAcceptedAt";
const COOKIE_CONSENT_DURATION_MS = 60 * 24 * 60 * 60 * 1000;



function MainPage() {
    const [index, setIndex] = useState(0);
    const [showCookiePopup, setShowCookiePopup] = useState(false);

    const moveSlide = (direction) => {
        let newIndex = index + direction;

        if (newIndex < 0) newIndex = 3;   // 4 images → last index
        if (newIndex > 3) newIndex = 0;   // back to first

        setIndex(newIndex);

        const track = document.getElementById("sliderTrack");

        // ⭐ dynamic width — works on desktop + mobile
        const imgWidth = track.querySelector("img").clientWidth;

        track.style.transform = `translateX(-${newIndex * imgWidth}px)`;
    };

    useEffect(() => {
        const interval = setInterval(() => {
            moveSlide(1);
        }, 5000); // every 5 seconds

        return () => clearInterval(interval);
    });

    useEffect(() => {
        const savedConsent = localStorage.getItem(COOKIE_CONSENT_KEY);

        if (!savedConsent) {
            setShowCookiePopup(true);
            return;
        }

        const acceptedAt = Number(savedConsent);
        const isExpired = Number.isNaN(acceptedAt)
            || Date.now() - acceptedAt > COOKIE_CONSENT_DURATION_MS;

        setShowCookiePopup(isExpired);
    }, []);

    const handleAcceptCookies = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, String(Date.now()));
        setShowCookiePopup(false);
    };

    const handleDeclineCookies = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, String(Date.now()));
        setShowCookiePopup(false);
    };

    return (
        <>
            
{/* GLOBAL SVG GRADIENT FOR STARS */}
      <svg width="0" height="0">
        <defs>
          <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFD700" />
            <stop offset="100%" stopColor="#FFA500" />
          </linearGradient>
        </defs>
      </svg>


            {/* NAVBAR */}
            <div className="navbar">
                {/* <div className="navbar-left">🔥 Kebab Haus Unterliederbach</div> */}
<div className="navbar-left">
  🔥 <span className="neon-wrapper"><span className="neon-red">DÖNER</span></span> – Unterliederbach
</div>

                <div className="navbar-right">
                    <a href="#menu" className="nav-icon"><FaUtensils /></a>
                    <a href="#angebot" className="nav-icon"><FaListAlt /></a>
                    <a href="#bewertungen" className="nav-icon"><FaStar /></a>
                </div>
            </div>

            {/* <div className="navbar">
        <div className="navbar-left">🔥 Kebab Haus Unterliederbach</div>
        <div className="navbar-right">
          <a href="#menu">Menü</a>
          <a href="#angebot">Unser Angebot</a>
          <a href="#bewertungen">Bewertungen</a>
        </div>
      </div> */}

           
            {/* MENU SECTION */}
<section id="menu" className="menu-section">
  <h2>Unser Menü</h2>

  {/* Red gradient line */}
  <div className="menu-line"></div>

  <p>Frisch, lecker und täglich für dich zubereitet.</p>
</section>

            {/* <section id="menu" className="menu-section">
                <h2>Unser Menü</h2>
                <p>Frisch, lecker und täglich für dich zubereitet.</p>
            </section> */}

            {/* MAIN IMAGE */}
            <div className="hero-image">
                <div className="hero-text">
                    <h1>Willkommen im Kebab Haus Unterliederbach</h1>
                    <p>Der beste Döner in Frankfurt am Main – frisch, saftig, authentisch.</p>
                </div>
            </div>



            {/* MAP + SLIDER ROW */}
            <div className="row-sections">
                {/* GOOGLE MAPS */}
                <section className="map-section">
                    <h2>Hier findest du uns</h2>
                    <p>Frankfurt am Main – Unterliederbach Bahnhof</p>

                    <iframe
                        title="Google Maps Schmalkaldener Str."
                        width="300"
                        height="300"
                        style={{ border: 0, borderRadius: "12px" }}
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="strict-origin-when-cross-origin"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d319.8527594851181!2d8.527484640526115!3d50.10833719154295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bda0cf4cb5ed33%3A0x5c23f0abd41491b0!2sSchmalkaldener%20Str.%2C%2065929%20Frankfurt%20am%20Main%20West!5e0!3m2!1sde!2sde!4v1783266030773!5m2!1sde!2sde"
                    />


                </section>


                {/* AUTO SLIDER WITH ARROWS */}
                <section className="auto-slider-section">
                    <h2>Bilder aus unserem Kebab Haus</h2>

                    <div className="auto-slider-wrapper">
                        <button className="arrow left" onClick={() => moveSlide(-1)}>❮</button>

                        <div className="auto-slider">
                            <div className="auto-slider-track" id="sliderTrack">
                                <img src="../img/slider1.jpg" alt="Slider 1" />
                                <img src="../img/slider2.jpg" alt="Slider 2" />
                                <img src="../img/slider3.jpg" alt="Slider 3" />
                                <img src="../img/slider4.jpg" alt="Slider 4" />
                            </div>
                        </div>

                        <button className="arrow right" onClick={() => moveSlide(1)}>❯</button>
                    </div>
                </section>
            </div>



            {/* UNSER ANGEBOT */}
            <section id="angebot" className="angebot-section">
                <h2>Unser Angebot</h2>
                <ul>
                    <li>Döner Kebap – klassisch oder mit extra Fleisch</li>
                    <li>Dürüm – frisch gerollt</li>
                    <li>Falafel – hausgemacht</li>
                    <li>Pide – traditionell aus dem Steinofen</li>
                    <li>Pommes – knusprig und heiß</li>
                </ul>
            </section>





            {/* BEWERTUNGEN */}
            <section id="bewertungen" className="bewertung-section">
                <h2>Bewertungen unserer Kunden</h2>

                <div className="review">
                    <div className="stars">
                    </div>
                    <p>„Bester Döner in Frankfurt! Frisch und super lecker.“ – Ümit</p>
                    <div className="stars">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                    </div>
                </div>

                <div className="review">
                    <div className="stars">
                    </div>
                    <p>„Sehr freundliches Team und schnelle Bedienung.“ – Ayhan</p>

                    <div className="stars">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                    </div>
                </div>
                <div className="review">
                    <div className="stars">
                    </div>
                    <p>„Der Dürüm ist ein Traum. Immer wieder gerne!“ – Tobi</p>
                    <div className="stars">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                    </div>
                </div>
            </section>

            {/* BEWERTUNGEN
      <section id="bewertungen" className="bewertung-section">
        <h2>Bewertungen unserer Kunden</h2>
        <div className="review">
          <p>„Bester Döner in Frankfurt! Frisch und super lecker.“ – Markus</p>
        </div>
        <div className="review">
          <p>„Sehr freundliches Team und schnelle Bedienung.“ – Aylin</p>
        </div>
        <div className="review">
          <p>„Der Dürüm ist ein Traum. Immer wieder gerne!“ – Tom</p>
        </div>
      </section> */}

            {/* FOOTER */}
            <footer className="footer">
                <p>© 2026 Kebab Haus Unterliederbach – Frankfurt am Main</p>
            </footer>

            {showCookiePopup && (
                <div className="cookie-popup" role="dialog" aria-live="polite" aria-label="Cookie Hinweis">
                    <p>
                        Wir verwenden Cookies, um die Nutzung der Website zu verbessern.
                        Du kannst Cookies akzeptieren oder ablehnen.
                    </p>
                    <div className="cookie-popup-actions">
                        <button type="button" className="decline-btn" onClick={handleDeclineCookies}>Ablehnen</button>
                        <button type="button" onClick={handleAcceptCookies}>Akzeptieren</button>
                    </div>
                </div>
            )}
        </>
    );
}

export default MainPage;
